import React, { useEffect, useState } from "react";
import {
  getTypeObject,
  updateTypeObject,
  updatePlayerAttribute,
} from "../../firebase/fireFuncs";
import useHover from "../../hooks/useHover";
import useModal from "../../hooks/useModal";
import PickListModal from "../../modals/PickListModal";
import { toast } from "react-toastify";
import MainStore from "../../stores/MainStore";
import { objectToArray } from "../helperfuncs";
import useHandleBoxTypes from "../../hooks/useHandleBoxTypes";

const PickList = ({
  type,
  onEntered,
  onRemove,
  inputRef,
  list,
  selectedItems,
}) => {
  const { getPluralType } = useHandleBoxTypes();
  const { player } = MainStore();
  const [newEntry, setNewEntry] = useState("");
  const [itemList, setItemList] = useState([]);
  const hover = useHover();
  const secondHover = useHover();

  function onTypeObjectReceived(typeObject) {
    if (typeObject[newEntry.toLocaleLowerCase()]) {
      typeObject[newEntry.toLocaleLowerCase()] += 1;
      updateTypeObject(getPluralType(type), list, typeObject, () => {
        onEntered(newEntry, list);
        setItemList(objectToArray(typeObject));
        setNewEntry("");
        increaseEntryEntered();
      });
    } else {
      typeObject[newEntry.toLocaleLowerCase()] = 1;
      updateTypeObject(getPluralType(type), list, typeObject, () => {
        onEntered(newEntry, list);
        setItemList(objectToArray(typeObject));
        setNewEntry("");
      });
    }
  }

  function addPickListToType() {
    if (player.added[list][getPluralType(type)] < 25) {
      if (newEntry.length > 3) {
        getTypeObject(getPluralType(type), list, onTypeObjectReceived);
      } else toast(`${list} names have to be at least 4 Characters`);
    } else toast(`You already added 5 ${list} for the type ${type}`);
  }

  function increaseEntryEntered() {
    const newAddedPicklist = {
      ...player.added[list],
      [getPluralType(type)]: player.added[list][getPluralType(type)] + 1,
    };
    updatePlayerAttribute(player.uid, `added.${list}`, newAddedPicklist);
  }

  function onEnter(e) {
    if (e.key == "Enter") addPickListToType();
  }

  const modal = useModal({
    password: "openPicklist",
    modalContent: (
      <PickListModal
        onItemPicked={(key) => onEntered(key, list)}
        itemList={itemList}
        pickedItems={selectedItems}
      />
    ),
  });

  useEffect(() => {
    function onListRetrieved(listObject) {
      setItemList(objectToArray(listObject));
    }
    getTypeObject(getPluralType(type), list, onListRetrieved);
  }, []);

  return (
    <div
      className="divColumn"
      style={{ width: "100%", justifyContent: "center" }}
    >
      <div
        className="divRow"
        style={{
          height: "20px",
          width: "100%",
          justifyContent: "center",
          marginBottom: "2px",
          marginTop: "2px",
        }}
      >
        {selectedItems.map((i, index) => (
          <div
            onClick={() => {
              onRemove(i, list);
            }}
            key={index}
            style={{
              fontStyle: "italic",
              fontFamily: "Roboto-Regular",
              color: "#353535",
              marginLeft: "5px",
              backgroundColor: "#c3c3c3",
              border: "1px solid gray",
              padding: "2px",
              borderRadius: ".2rem/.2rem",
            }}
          >
            {i}
          </div>
        ))}
      </div>
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "center" }}
      >
        <input
          maxLength={25}
          onKeyDown={onEnter}
          ref={inputRef}
          value={newEntry}
          onChange={(e) => setNewEntry(e.target.value.replace(/[^a-z]/gi, ""))}
          style={{ backgroundColor: "#e3e3e3", textAlign: "center" }}
          placeholder={`add new entry to ${list}`}
        />
        <button
          onClick={addPickListToType}
          {...hover.divProps}
          style={{
            fontFamily: "Roboto-Bold",
            backgroundColor: "#e3e3e3",
            color: hover.hover ? "brown" : "gray",
          }}
        >
          Add
        </button>

        <button
          onClick={() => modal.open("openPicklist")}
          {...secondHover.divProps}
          style={{
            fontFamily: "Roboto-Bold",
            backgroundColor: "#353535",
            color: secondHover.hover ? "gold" : "white",
            marginLeft: "10px",
            padding: "2px",
            borderRadius: ".2rem/.2rem",
          }}
        >
          Pick
        </button>
      </div>
      {modal.element}
    </div>
  );
};

export default PickList;
